import { VenueDefaultDatas } from '@/domain/project-venue/entities/project-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const saveVenueDefaultDatas = createAppAsyncThunk(
  'projectVenue/saveVenueDefaultDatas',
  async (
    body: { projectId: number; properties: VenueDefaultDatas },
    { extra: { projectVenueGateway, snackbarGateway } },
  ): Promise<{ success: boolean }> => {
    try {
      const result = await projectVenueGateway.saveVenueDefaultDatas(body);
      showSnackbarSuccess(snackbarGateway);
      return result;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('SaveVenueDefaultDatas.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('SaveVenueDefaultDatas.Message.error'));
}
